import * as React from "react";
import { MultiSelectComponent, CheckBoxSelection, Inject } from "@syncfusion/ej2-react-dropdowns";
import "./index.css";
import PropTypes from "prop-types";

const CheckBoxGrouping = (props) => {
  const {
    dataSource,
    placeholder,
    checkFields,
    enableGroupCheckBox = true,
    allowFiltering = true,
    mode = "CheckBox",
    filterBarPlaceholder = "",
    selectedValues,
    setSelectedValues,
    setSelectedCategories,
    callBackFuction = () => {},
    width = "auto",
    customClass = "",
    enabled = true,
    dropDownIconSize
  } = props;

  const handleChange = (event) => {
    setSelectedValues(event.value);
    const selectedCategories = [...new Set(event.value.map((id) => dataSource?.find((item) => item.value === id)?.category))];
    if (selectedCategories?.length > 0) setSelectedCategories?.(selectedCategories);
    else setSelectedCategories?.([]);
    callBackFuction?.(event);
  };

  return (
    <div id="checkboxgroup" className={`control-pane checkBoxGroupingDropDown ${customClass}`}>
      <style>
        {`
        .${customClass} .e-multiselect.e-input-group .e-ddl-icon::before {
          font-size: ${dropDownIconSize || "16px"} !important;
                display: inline-block;
      vertical-align: middle;
      line-height: 1;
        }
      `}
      </style>
      <div className="control-section" style={{ width: width }}>
        <MultiSelectComponent
          id="checkbox"
          dataSource={dataSource}
          filterBarPlaceholder={filterBarPlaceholder}
          fields={checkFields}
          placeholder={placeholder}
          mode={mode}
          floatLabelType="Auto"
          showSelectAll={true}
          enableGroupCheckBox={enableGroupCheckBox}
          showDropDownIcon={true}
          enableSelectionOrder={false}
          allowFiltering={allowFiltering}
          cssClass={"customCss e-outline"}
          value={selectedValues}
          change={handleChange}
          enabled={enabled}
        >
          <Inject services={[CheckBoxSelection]} />
        </MultiSelectComponent>
      </div>
    </div>
  );
};
export default CheckBoxGrouping;

CheckBoxGrouping.propTypes = {
  dataSource: PropTypes.array,
  placeholder: PropTypes.string,
  checkFields: PropTypes.object,
  enableGroupCheckBox: PropTypes.bool,
  allowFiltering: PropTypes.bool,
  mode: PropTypes.string,
  filterBarPlaceholder: PropTypes.string,
  selectedValues: PropTypes.array,
  setSelectedValues: PropTypes.func,
  setSelectedCategories: PropTypes.func,
};

CheckBoxGrouping.defaultProps = {
  enableGroupCheckBox: true,
  allowFiltering: true,
  mode: "CheckBox",
  filterBarPlaceholder: "",
  selectedValues: [],
};
